import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/config";

export interface HealthState {
  loading: boolean;
  ok: boolean;
  dbConnected: boolean;
  raw: unknown;
}

export function useHealth(): HealthState {
  const [state, setState] = useState<HealthState>({
    loading: true,
    ok: false,
    dbConnected: false,
    raw: null,
  });

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/health`)
      .then((res) => {
        if (!active) return;
        const data = res.data;
        setState({
          loading: false,
          ok: data?.status === "ok",
          dbConnected: Boolean(data?.database?.connected),
          raw: data,
        });
      })
      .catch(() => {
        if (!active) return;
        setState({ loading: false, ok: false, dbConnected: false, raw: null });
      });
    return () => {
      active = false;
    };
  }, []);

  return state;
}
